const getters = {
    fileName: state => state.dataset.currentFileName,
    currentDegTaskId: state => state.dataset.currentDegTaskId,
    currentPathTaskId: state => state.dataset.currentPathTaskId,
};
export default getters;